// extracted by mini-css-extract-plugin
module.exports = {"embedded-video-wrapper":"article-news-document_embedded-video-wrapper__ZYxjZ","embedded-video":"article-news-document_embedded-video__BfQ7q"};